import type { ApprovalDto, ApprovalKind } from '@werft/contracts';
import { t } from '../../i18n/index.js';
import { ApiError, newOpId, newUuid } from '../../platform/api.js';
import { keys, queryClient } from '../../platform/queries.js';
import { outbox } from '../../platform/sync.js';
import { toast } from '../../platform/toast.js';

/**
 * Abnahme (Audit 0.36 Etappe C, ADR 0035): Schreibwege über den Ausgangskorb. Wird beim Start geladen (Handler müssen
 * registriert sein), deshalb klein und ohne Oberfläche – die steht in `ApprovalPanel.tsx` (getrennt geladen).
 */
const reload = (pid: string, a?: Pick<ApprovalDto, 'kind' | 'targetId'>) => {
  void queryClient.invalidateQueries({ queryKey: a ? ['p', pid, 'approvals', a.kind, a.targetId] : ['p', pid, 'approvals'] });
  void queryClient.invalidateQueries({ queryKey: keys.overview(pid), refetchType: 'active' });
  void queryClient.invalidateQueries({ queryKey: ['p', pid, 'register'] });
};
const failed = (pid: string) => (_e: unknown, err: unknown) => {
  reload(pid);
  toast(err instanceof ApiError ? err.message : t('approval.failed'), { kind: 'error' });
};
for (const kind of ['approval.request', 'approval.decide', 'approval.withdraw'])
  outbox.register(kind, { done: (e, r) => reload(e.projectId, r as ApprovalDto), fail: (e, err) => failed(e.projectId)(e, err) });

export function requestApproval(projectId: string, input: { kind: ApprovalKind; targetId: string; approverId: string; message?: string; dueDate?: string | null }) {
  const opId = newOpId();
  void outbox.enqueue({ opId, kind: 'approval.request', projectId, method: 'POST', url: `/api/projects/${projectId}/approvals`, body: { opId, id: newUuid(), ...input } }).catch(() => {});
  toast(t('approval.requested'));
}

export function decideApproval(a: ApprovalDto, decision: 'approved' | 'changes', comment?: string) {
  const opId = newOpId();
  void outbox
    .enqueue({ opId, kind: 'approval.decide', projectId: a.projectId, method: 'POST', url: `/api/approvals/${a.id}/decide`, body: { opId, decision, ...(comment ? { comment } : {}) } })
    .catch(() => {});
  toast(decision === 'approved' ? t('approval.doneApproved') : t('approval.doneChanges'));
}

export function withdrawApproval(a: ApprovalDto) {
  const opId = newOpId();
  void outbox.enqueue({ opId, kind: 'approval.withdraw', projectId: a.projectId, method: 'POST', url: `/api/approvals/${a.id}/withdraw`, body: { opId } }).catch(() => {});
}
